"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@phishtool/ui/src/assets");
// Generated by scripts/svg-sprite — imported so webpack emits it and the manifest can resolve it
require("./logo-sprite.svg");
